import cx from 'classnames';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { RD_COMPONENTS } from '../_utils';
import { Icon, IconColor, IconID, IconSize } from '../icon';
import styles from './text-area.module.scss';
export const TextArea = ({ value, ariaLabel, id, name, className = '', textAreaClassName, onGrayBackground = false, hasError = false, helperText, disabled, onChange = _.noop, onFocus = _.noop, onBlur = _.noop, rows = 3, grow, readOnly, textAreaRef, ...restProps }) => {
    const textareaID = id || (name ? `textarea-${name}` : name);
    const [inputValue, setInputValue] = useState(value);
    const [hasFocus, setHasFocus] = useState(false);
    const handleChange = (event) => {
        onChange(event);
        setInputValue(event.target.value);
    };
    const handleFocus = (event) => {
        onFocus(event);
        setHasFocus(true);
    };
    const handleBlur = (event) => {
        onBlur(event);
        setHasFocus(false);
    };
    useEffect(() => {
        setInputValue(value);
    }, [value]);
    const containerClassNames = cx(className, styles.container, {
        [styles.hasError]: hasError,
        [styles.hasFocus]: hasFocus,
        [styles.onGrayBackground]: onGrayBackground,
        [styles.grow]: grow,
    });
    const textAreaClassNames = cx(styles.textarea, {
        [styles.hasError]: hasError,
        [styles.readOnly]: readOnly,
        [styles.onGrayBackground]: onGrayBackground,
    }, textAreaClassName);
    const getHelpTextMarkup = () => {
        if (helperText) {
            const helperTextClassName = cx(styles.helperText, {
                [styles.hasError]: hasError,
                [styles.disabled]: disabled,
            });
            return (React.createElement("span", { className: helperTextClassName },
                hasError && (React.createElement("span", { className: styles.iconStyle },
                    React.createElement(Icon, { color: IconColor.TEXT_COLOR, size: IconSize.XSMALL, id: IconID.EXCLAMATION_POINT_CIRCLE }))),
                helperText));
        }
        return null;
    };
    return (React.createElement("div", { "data-radiant-v2": true },
        React.createElement("div", { className: containerClassNames, id: id },
            React.createElement("textarea", { ref: textAreaRef, rows: rows, value: inputValue, "aria-label": ariaLabel, onFocus: handleFocus, onBlur: handleBlur, id: textareaID, onChange: handleChange, className: textAreaClassNames, disabled: disabled, readOnly: readOnly, ...restProps }),
            getHelpTextMarkup())));
};
TextArea.RD_COMPONENT = RD_COMPONENTS.TEXTAREA;
//# sourceMappingURL=text-area.js.map